module.exports = __webpack_public_path__ + "static/media/logo.d60f2e16.svg";